import { g as global$1 } from './p-c44c2366.js';

const callbacks = new WeakMap();
let observer;
if (typeof MutationObserver !== 'undefined') {
    observer = new MutationObserver((mutations) => {
        mutations.forEach(function (mutation) {
            var _a;
            if (mutation.type === 'attributes') {
                (_a = callbacks
                    .get(mutation.target)) === null || _a === void 0 ? void 0 : _a.forEach((callback) => { var _a; return callback(((_a = mutation.target.getAttribute('mode')) !== null && _a !== void 0 ? _a : 'light')); });
            }
        });
    });
}
function closestElement(selector, target) {
    const found = target.closest(selector);
    if (found) {
        return found;
    }
    const root = target.getRootNode();
    if (root === global$1.document || !(root instanceof ShadowRoot)) {
        return null;
    }
    return closestElement(selector, root.host);
}
function consumeMode(component, onChange) {
    var _a;
    const mode = closestElement(transformTagName('cosmos-mode'), component.element);
    if (!mode) {
        return;
    }
    // Important: using getAttribute ensures that we get the correct mode value even when cosmos-mode is not registered yet
    onChange(((_a = mode.getAttribute('mode')) !== null && _a !== void 0 ? _a : 'light'));
    if (callbacks.has(mode)) {
        callbacks.get(mode).push(onChange);
    }
    else {
        observer === null || observer === void 0 ? void 0 : observer.observe(mode, { attributes: true });
        callbacks.set(mode, [onChange]);
    }
}

function resolveAppearance({ instance, modeToAppearanceMap, callback }) {
    if (instance.appearance) {
        callback(instance.appearance);
    }
    else {
        consumeMode(instance, (mode) => {
            if (!instance.appearance) {
                callback(modeToAppearanceMap[mode]);
            }
        });
    }
}

/**
 * Transform the tagname with a version suffix if necessary
 *
 * @returns {boolean} Returns the tagname if in a scoped environment,
 * else the unstranformed tagname
 */
const transformTagName = (tag) => {
    return tag;
};

export { resolveAppearance as r, transformTagName as t };
